export function anyAvailable(systems) {
  if (!systems) {
    return false;
  }
  return Boolean(Object.values(systems).find(s => s.availableAt && !s.archivedAt));
}
